import { find, get } from 'lodash';
import { ReduxStoreBridge } from '../../../infra/redux-bridge';
import { persistentKVStore } from '../../../infra/persistence';
var emailOrFallback = function (maybeEmail, fallback) {
    var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return !!maybeEmail && emailRegex.test(maybeEmail) ? maybeEmail : fallback;
};
export var getUserInfo = function () {
    var user = ReduxStoreBridge.getOnce('auth.user') || null;
    if (!user) {
        return {
            name: '',
            email: '',
            username: '',
        };
    }
    var brand = user.brand;
    var activeShopId = persistentKVStore.getItem('shop');
    var isBrandView = !!user.brand && !activeShopId;
    if (isBrandView) {
        return {
            name: '',
            email: emailOrFallback(user.username, brand.email),
            username: user.username,
        };
    }
    var activeBarber = get(user, 'barbers[0]');
    var activeShop = find(user.shops, { id: activeShopId }) || get(activeBarber, 'shop') || get(user, 'shops[0]');
    var isShopView = !!activeShop && !activeBarber;
    if (isShopView) {
        return {
            name: '',
            email: emailOrFallback(user.username, activeShop.email),
            username: user.username,
        };
    }
    if (activeBarber) {
        return {
            name: "".concat(activeBarber.firstName, " ").concat(activeBarber.lastName),
            email: emailOrFallback(user.username, activeBarber.email),
            username: user.username,
        };
    }
    return {
        name: '',
        email: emailOrFallback(user.username, ''),
        username: user.username,
    };
};
